import Vue from 'vue'
import com from 'js/common.js'
import 'scss/pages/register'
import agreement from 'common/agreement'


var app = new Vue({
    el: '#app',
    data: {
        active:0,
        // isRemember: false,
        form: {},
        form2: {},
        rules: {
            mobile_tel: [
                { validator: validateMobile,required: false, trigger: 'blur' }
            ]
        },
        rules2: {
            smsCode: [
                { validator: validateCode,required: false, trigger: 'blur' }
            ],
            password: [
                { validator: validateLoginPass,required: false, trigger: 'blur' }
            ],
            captcha: [
                { required: true, message: '请输入图片验证码', trigger: 'blur' }
            ]
        },
        canSend: true,
        isSend: false,
        times: 0,
        codeBtnText: '获取验证码',
        timer: '',
        dialogTableVisible: false,
        codeImgUrl: '',
        // 滑块验证
        slideLeft: '',
        mouseMoveStata: false,
        eFirst: '',
        eEnd: '',
        btnMar: '0',
        slideUrl: '',
        slideBtnUrl: '',
        ySize: '',
        font: true
    },
    components: {agreement},
    mounted: function (){
        this.getCaptcha()
        // 鼠标移动触发
        $('body').on('mousemove', (e) => {
            var that = this
            //拖动，这里需要用箭头函数，不然this的指向不会是vue对象 
            if(this.mouseMoveStata) {
                that.eEnd = e.pageX
                if((that.eEnd-that.eFirst)>=0&&(that.eEnd-that.eFirst)<=240){
                    that.btnMar = that.eEnd-that.eFirst
                    document.getElementsByClassName('slideBtn')[0].style.left = that.btnMar+'px'
                    document.getElementsByClassName('slideBtnBox')[0].style.left = that.btnMar+'px'
                    if((that.eEnd-that.eFirst)>0){
                        that.font = false
                        document.getElementsByClassName('bgDiv')[0].style.width = that.btnMar+'px'
                    }
                }
            }
        });
        // 鼠标抬起触发
        $('body').on('mouseup', (e) => {
            //鼠标放开 
            var that = this
            var data = {
                mobile: this.form.mobile_tel,
                target: 3,
                y:that.ySize,
                x:that.btnMar
            }
            if(this.mouseMoveStata) {
                this.mouseMoveStata = false;
                that.post('sms/slide/check', data, {
                    isLoading: true,
                    notLogin: true,
                    isToken: '1',
                    success: function (res){
                        if(res){
                            document.getElementsByClassName('bgDiv')[0].style.backgroundColor = 'rgba(82, 205, 189,0.3)'
                            document.getElementsByClassName('slideBtn')[0].style.backgroundColor = 'rgba(82, 205, 189,1)'
                            document.getElementsByClassName('slideBtn')[0].style.backgroundImage = 'url(/accountcenter/static/images/slideImg/duihao1.png)'
                            var vm = that
                            setTimeout(function () {
                                vm.successUser()
                            },1000);
                        }else{
                            document.getElementsByClassName('bgDiv')[0].style.backgroundColor = 'rgba(229, 82, 85, 0.3)'
                            document.getElementsByClassName('slideBtn')[0].style.backgroundColor = 'rgba(229, 82, 85, 1)'
                            document.getElementsByClassName('slideBtn')[0].style.backgroundImage = 'url(/accountcenter/static/images/slideImg/cuohao1.png)'
                            var vmm = that
                            setTimeout(function () {
                                vmm.refreshImg()
                            },1000);
                            
                        }
                    }
                })
            }
            // this.mouseMoveStata = false;
        })
    },
    methods: {
        // 鼠标按下触发
        aaa: function (e){
            var that = this
            that.mouseMoveStata = true
            that.eFirst = e.pageX
            document.getElementsByClassName('slideBtn')[0].style.backgroundImage = 'url(/accountcenter/static/images/slideImg/jiantou2.png)'
            document.getElementsByClassName('slideBtn')[0].style.backgroundColor = 'rgba(42, 98, 255, 1)'
            console.log(1,that.eFirst)
        },
        // 弹窗显示
        bbb: function (){
            var that = this
            var data = {
                mobile_tel: this.form.mobile_tel,
                target: 3
            }

            this.$refs['form'].validate(function (valid){
                if(valid){
                    that.post('sms/verifyAndSend', data, {
                        isLoading: true,
                        notLogin: true,
                        isToken: '1',
                        success: function (res){
                            if(res.success_type === 101){
                                that.refreshImg()
                            } else if (res.success_type === 102){
                                that.$alert(res.error_info, '提示')
                                return false;
                            }else if (res.success_type === 103){
                                that.$alert(res.error_info, '提示')
                                return false;
                            }else if (res.success_type === '1'){
                                that.$alert(res.error_info, '提示')
                                return false;
                            }else if (res.success_type === '0'){
                                that.successUser()
                            }
                        }
                    })
                }
            })
          
        },
        // 获取图片
        refreshImg: function () {
            console.log(123123123123)
            var that = this
            var datas = {
                mobile: that.form.mobile_tel,
                target: 3
            }
            document.getElementsByClassName('bgDiv')[0].style.backgroundColor = 'rgba(42, 98, 255, 0.3)'
            document.getElementsByClassName('slideBtn')[0].style.backgroundColor = 'rgba(255, 255, 255, 1)'
            document.getElementsByClassName('slideBtn')[0].style.backgroundImage = 'url(/accountcenter/static/images/slideImg/jiantou1.png)'
            document.getElementsByClassName('slideBtn')[0].style.left = '0px'
            document.getElementsByClassName('slideBtnBox')[0].style.left = '0px'
            that.font = true
            document.getElementsByClassName('bgDiv')[0].style.width = '0px'
            that.get('sms/getSlide', datas, {
                isLoading: true,
                notLogin: true,
                isToken: '1',
                success: function (res){
                    that.slideUrl = 'data:image/jpg;base64,' + res.shadeImage
                    that.slideBtnUrl = 'data:image/png;base64,' + res.cutoutImage
                    that.ySize = res.y
                    document.getElementsByClassName('slideBtnUrl')[0].style.top = that.ySize+'px'
                    that.dialogTableVisible = true
                }
            })
        },
        // 成功
        successUser: function () {
            console.log(111)
            var that = this
            document.getElementsByClassName('bgDiv')[0].style.backgroundColor = 'rgba(42, 98, 255, 0.3)'
            document.getElementsByClassName('slideBtn')[0].style.backgroundColor = 'rgba(255, 255, 255, 1)'
            document.getElementsByClassName('slideBtn')[0].style.backgroundImage = 'url(/accountcenter/static/images/slideImg/jiantou1.png)'
            that.dialogTableVisible = false
            that.isSend = true
            that.times = 60;
            that.canSend = false;
            that.codeBtnText = that.times + '秒后获取'
            that.timer = setInterval(function (){
                that.times --;
                that.codeBtnText = that.times + '秒后获取';
                if(that.times == 0){
                    that.canSend = true;
                    that.codeBtnText = '获取验证码'
                    clearTimeout(that.timer)
                }
            }, 1000)
        },
        getCode: function (){
            sessionStorage.setItem('access_token', ''); //重置access_token为空，便于调用'sms/code/req'时需验证
            var that = this
            var data = {
                mobile_tel: this.form.mobile_tel,
                target: 3
            }
            this.$refs['form'].validate(function (valid){
                if(valid){
                    that.post('sms/code/req', data, {
                        isLoading: true,
                        notLogin: true,
                        isToken: '1',
                        success: function (res){
                            if(res.success_type == 0){
                                that.isSend = true
                                that.times = 60;
                                that.canSend = false;
                                that.codeBtnText = that.times + '秒后获取'
                                that.timer = setInterval(function (){
                                    that.times --;
                                    that.codeBtnText = that.times + '秒后获取';
                                    if(that.times == 0){
                                        that.canSend = true;
                                        that.codeBtnText = '获取验证码'
                                        clearTimeout(that.timer)
                                    }
                                }, 1000)
                            }else if(res.success_type == 32){
                                that.isSend = true
                                that.$alert(res.error_info, '提示')
                            }else{
                                that.$alert(res.error_info, '提示')
                            }
                        }
                    })
                }
            })
        },
        query: function (){
            var that = this
            var data = {
                username: this.form.mobile_tel,
                smsCode: this.form2.smsCode,
                password: this.form2.password,
                source:'web'
            }
            this.$refs['form'].validate(function (valid){
                if(valid){
                    that.$refs['form2'].validate(function (valid2){
                        if(valid2){
                            if(!that.isSend){
                                that.$alert('请先获取验证码')
                                return false
                            }
                            // if(!that.isRemember){
                            //     that.$alert('请先阅读《沈阳麟龙网上交易协议》及《证券投资基金投资人权益须知》', '提示')
                            //     return false
                            // }
                            that.post('fund/user/register', data, {
                                isLoading: true,
                                notLogin: true,
                                isToken: '1',
                                success: function (res){
                                    if(res.success_type == 0){
                                        that.doLogin()
                                    }else if(res.success_type == 15){
                                        that.doLogin()
                                    }else{
                                        that.$alert(res.error_info, '提示')
                                    }
                                }
                            })
                        }
                    })
                }
            });
        },
        doLogin: function (){
            var data = {
                username: this.form.mobile_tel,
                password: this.form2.password,
                grant_type: 'password',
                scope: 'web',
                client_id: 'client_fund_password',
                client_secret: 123456,
                login_type: 'mobile',
                flowId: sessionStorage.getItem('flowId'),
                captcha: this.form2.captcha
            }
            var that = this;
            $.ajax({
                type: 'POST',
                url: window.platformUrl + 'oauth/token'
                + '?username=' + this.form.mobile_tel
                + '&password=' + this.form2.password
                + '&grant_type=password'
                + '&scope=web'
                + '&client_id=client_fund_password'
                + '&client_secret=' + 123456
                + '&login_type=mobile'
                + '&flowId=' + sessionStorage.getItem('flowId')
                + '&captcha=' + this.form2.captcha,
                data: data,
                dataType: 'json',
                success: function (res){
                    if(res.code == 200){
                        $.ajax({
                            type: 'GET',
                            url: window.platformUrl + 'api/1.0.0/member/getProfile',
                            data: {
                                access_token: res.access_token
                            },
                            dataType: 'json',
                            success: function (res2){
                                if(res2.code == 200){
                                    sessionStorage.setItem('access_token', res.access_token);
                                    sessionStorage.setItem('refresh_token', res.refresh_token);
                                    sessionStorage.setItem('username', res2.content.mobileNumber);
                                    sessionStorage.setItem('loginInfo', JSON.stringify(res2.content));

                                    that.post('ufx/assets/load', {username: res2.content.mobileNumber}, {
                                        success: function (res3){
                                            that.hideLoading()
                                            if(res2.regStep == 0){
                                                that.$alert('用户已注册', '提示')
                                                return false
                                            }
                                            // window.location.href = '/accountcenter/register/bank.html?username=' + res2.content.mobileNumber
                                            window.location.href = '/accountcenter/register/user-info.html?username=' + res2.content.mobileNumber

                                        }
                                    })
                                }else{
                                    that.hideLoading()
                                    that.$alert(res.message, '提示')
                                }
                            }
                        })
                    }else{
                        that.hideLoading()
                        that.refreshCaptcha()
                        that.$alert(res.message, '提示')

                        if(res.status == '1108' || res.status == '1107'){
                            that.imgCode = ''
                            $('#code').focus()
                        }
                    }
                }
            });
        },
        getCaptcha: function (){
            var that = this
            $.ajax({
                type: 'GET',
                url: window.platformUrl + 'system/captcha',
                dataType: 'json',
                success: function (res){
                    if(res.code == 200){
                        sessionStorage.setItem('flowId', res.content.flowId);
                        that.codeImgUrl = 'data:image/png;base64,' + res.content.captcha
                    }else{
                        that.$alert(res.message, '提示')
                    }
                }
            });
        },
        refreshCaptcha: function (){
            var that = this
            $.ajax({
                type: 'GET',
                url: window.platformUrl + 'system/refresh/captcha',
                data: {
                    flowId: sessionStorage.getItem('flowId')
                },
                dataType: 'json',
                success: function (res){
                    if(res.code == 200){
                        sessionStorage.setItem('flowId', res.content.flowId);
                        that.codeImgUrl = 'data:image/png;base64,' + res.content.captcha
                    }else{
                        that.$alert(res.message, '提示')
                    }
                }
            });
        },
        backIndex: function () {
            window.location.href = window.backIndexUrl;
        }
    }  
})



//////////////////
// WEBPACK FOOTER
// ./views/register/account.js
// module id = TaZ7
// module chunks = 3